<template>
    <div class="perfil-form">
        <form @submit.prevent="submit"
            ref="login-form-form"
            novalidate
            :class="{
                'validated': validated
            }"
            v-if="!isSubmitting">
            <div class="row perfil-tab-row">
                <div class="col-12">
                    <h3>Acceso</h3>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="login-form-email">Email <span class="color-red">*</span></label>
                        <input type="email"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && (email == '' || !isEmailValid),
                                'is-valid': validated && isEmailValid && email != ''
                            }"
                            name="email"
                            id="login-form-email"
                            aria-describedby="emailHelp"
                            placeholder="Email"
                            required
                            autocomplete="off"
                            v-model="email">
                        <div class="invalid-feedback">Email inválido</div>
                        <div class="valid-feedback" v-if="validated && email != user.email">Enviaremos un email a esta dirección para confirmar el cambio.</div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <div class="form-group">
                        <label for="login-form-password">Cambiar password</label>
                        <input type="password"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && (password == '' && password != repeatPassword),
                                'is-valid': validated && password != '' && password == repeatPassword
                            }"
                            name="password"
                            id="login-form-password"
                            placeholder="Nuevo password"
                            autocomplete="off"
                            v-model="password">
                        <div class="invalid-feedback">Password inválido</div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <div class="form-group">
                        <label for="login-form-repeat">Repetir nuevo password</label>
                        <input type="password"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && (repeatPassword == '' && password != repeatPassword),
                                'is-valid': validated && repeatPassword != '' && password == repeatPassword
                            }"
                            name="repeat-password"
                            id="login-form-repeat"
                            placeholder="Repetir nuevo password"
                            v-model="repeatPassword">
                        <div class="invalid-feedback">El password no coincide</div>
                    </div>
                </div>
            </div>





            <div class="row">
                <div class="col-12">
                    <h3>Datos personales</h3>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="login-form-name">Nombres <span class="color-red">*</span></label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && name == ''
                            }"
                            id="login-form-name"
                            name="name"
                            aria-describedby="nameHelp"
                            placeholder="Nombres"
                            required
                            v-model="name">
                        <div class="invalid-feedback">Este campo no puede ir vacío.</div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="login-form-apellido">Apellidos <span class="color-red">*</span></label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && apellido == ''
                            }"
                            name="apellido"
                            id="login-form-apellido"
                            aria-describedby="apellidoHelp"
                            placeholder="apellido"
                            required
                            v-model="apellido">
                        <div class="invalid-feedback">Este campo no puede ir vacío.</div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="login-form-telefono">Teléfono Movil <span class="color-red">*</span></label>
                        <div class="row">
                        <div class="col-lg-4">
                           <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            placeholder="prefijo"
                            readonly
                            disabled
                            :value="'+'+this.portal.pais_portal.prefijo">
                        </div>
                        <div class="col-lg-8">
                        <input type="text"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                'is-valid': validated && (telefono != '' && isTelefonoValid )
                            }"
                            name="telefono"
                            id="registro-form-telefono"
                            aria-describedby="telefonoHelp"
                            placeholder="912345678"
                            v-model="telefono"
                            required
                            pattern="9[0-9]{8}"
                            title="9 dígitos comenzando con 9">
                        </div>
                        </div>
                        <div class="invalid-feedback">{{ telefono != '' ? 'El formato del número es incorrecto' : 'Este campo no puede ir vacío'   }}</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-8">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="login-form-genero">Fecha de nacimiento</label>

                                <input type="date"
                                       :class="{
                                        'form-control': true,
                                        }"
                                       v-model="fecha_nac" >
                                <div class="invalid-feedback">Este campo no puede ir vacío.</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="login-form-genero">Género <span class="color-red">*</span></label>
                                <select
                                    :class="'form-control ' + (validated && sexo == '' ? 'is-invalid': '')"
                                    name="sexo"
                                    id="login-form-sexo"
                                    aria-describedby="sexoHelp"
                                    placeholder="Sexo"
                                    required
                                    v-model="sexo">
                                    <option value=""></option>
                                    <option value="F" :selected="user.sexo == 'F'">Femenino</option>
                                    <option value="M" :selected="user.sexo == 'M'">Masculino</option>
                                    <option value="O" :selected="user.sexo == 'O'">Otro</option>
                                </select>
                                <div class="invalid-feedback">Este campo no puede ir vacío.</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="login-form-direccion">Dirección <span class="color-red">*</span></label>
                                <vue-google-autocomplete
                                    id="direccion"
                                    classname="form-control"
                                    placeholder="Buscar dirección..."
                                    :country="countrySlug"
                                    :value="direccion"
                                    @inputChange="newDireccion"
                                    @keypress="direccionKeyPress"
                                    @keyup="direccionKeyUp"
                                    />
                            </div>
                            <button class="btn btn-primary mb-10">Guardar
                            </button>
                            <div class="perfil-alert"
                                v-if="alert.visible">
                                <font-awesome-icon
                                    :icon="alert.icon"
                                    class="color-white"
                                    :class="{
                                        spin: alert.iconSpin
                                    }" />
                                    {{ alert.message }}
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="temas.length > 0" class="col-md-4">
                    <div class="row">
                        <div class="col-12">
                            <h3>Temas de interes</h3>
                        </div>
                        <div class="col-12" >
                            <draggable
                                :list="temas"
                                :disabled="!enabled"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                @start="dragging = true"
                                @end="dragging = false"
                            >

                                <div v-for="tema in temas"
                                    :key="tema.tema.id"
                                    class="list-group-item checkbox checkbox-aqua checkbox-label"
                                    :class="{'checkbox-checked': tema.activo}"
                                    @click="tema.activo = !tema.activo">
                                    <input type="checkbox" value="1" :checked="tema.activo" />
                                    {{ tema.tema.categoria }}
                                </div>

                            </draggable>
                        </div>

                    </div>
                </div>
            </div>
            <!-- debug plugin dragabble
            <div class="row">
                <rawDisplayer class="col-md-12" :value="temas" title="Temas" />
            </div>-->
            <div class="row perfil-tab-row" v-if="this.user.oneclick_cliente_card">
                <div class="col-12">
                    <h3>Tarjeta de Credito</h3>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="login-form">Digitos de la tarjeta : </label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            required
                            readonly
                            :value="this.user.oneclick_cliente_card.last4CardDigits">
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="login-form">Tipo de tarjeta : </label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            required
                            readonly
                            :value="this.user.oneclick_cliente_card.creditCardType">
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="login-form">Fecha de afiliacion : </label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            required
                            readonly
                            :value="this.user.oneclick_cliente_card.created_at">
                    </div>
                </div>
                <div class="col-lg-3">
                    <label>&nbsp;</label>
                    <div class="btn btn-primary mb-10" @click="anular_tarjeta">Quitar Tarjeta</div>
                </div>
            </div>

            <div class="row perfil-tab-row" v-if="this.user.paypal_oneclick">
                <div class="col-12">
                    <h3>Tarjeta de Credito</h3>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="login-form">Cuenta : </label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            required
                            readonly
                            :value="this.user.paypal_oneclick.PAYER_EMAIL">
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="login-form">Nombre : </label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            required
                            readonly
                            :value="this.user.paypal_oneclick.PAYER_NAME">
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="login-form">Fecha de afiliacion : </label>
                        <input type="text"
                            :class="{
                                'form-control': true,
                            }"
                            required
                            readonly
                            :value="this.user.paypal_oneclick.FECHA_TRANSACCION">
                    </div>
                </div>
                <div class="col-lg-3">
                    <label>&nbsp;</label>
                    <div class="btn btn-primary mb-10" @click="anular_tarjeta">Quitar Tarjeta</div>
                </div>
            </div>

        </form>

        <b-modal v-model="isResponseMessageModalVisible"
            :busy="true"
            centered
            hide-footer
            title="Notificación">
            <div class="text-center alert-text-box">
                <p :class="{
                        'color-gray': isGuardados
                        }">
            {{ MessageModal }}
            </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { randomString, isValidEmail, isValidTelefono } from "../utilities/util";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DatePicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import { es } from "vuejs-datepicker/src/locale";
import { format, toDate, isValid } from "date-fns";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import draggable from "vuedraggable";
import rawDisplayer from "../components/raw-displayer.vue";

library.add(faCheck, faSpinner);

export default {
	components: {
		VueGoogleAutocomplete,
		FontAwesomeIcon,
		DatePicker,
        bModal,
        draggable,
        rawDisplayer
	},
	props: ["countrySlug"],
	data() {
		return {
			alert: {
				message: "",
				visible: false,
				icon: "",
				iconSpin: false
			},
			id: 0,
			name: "",
			apellido: "",
			email: "",
			label: null,
			telefono: "",
			direccion: "",
			isSubmitting: false,
			password: "",
			repeatPassword: "",
			validated: false,
			temas: [],
			temasSelect: [],
			id_categoria: [],
			sexo: "",
            isResponseMessageModalVisible:false,
            MessageModal:"",
            isGuardados:false,
			fecha_nac: "",
            es,
            enabled: true,
            dragging: false
		};
	},
	computed: {
		isEmailValid() {
			return isValidEmail(this.email);
		},
		isTelefonoValid() {
			return isValidTelefono(this.telefono);
		},
		validFecha() {
			let d = toDate(this.fecha_nac);
			return isValid(d) ? format(d, "YYYY-MM-dd") : false;
		},
        ...mapGetters(["user", "portal", "userId"]),
        draggingInfo() {
            return this.dragging ? "under drag" : "";
        }
	},
	watch: {
		userId(val, old) {
			if (val != 0 && old == 0 && this.temas.length == 0) {
				console.log("cargandotemas", val);
				this.loadUserInfo();
				this.cargarTemas();
			}
		}
	},
	methods: {

        anular_tarjeta(){

            this.isResponseMessageModalVisible=true;
            this.MessageModal="Para poder anular su tarjeta de la suscripción enviar un correo a : "+this.portal.email_soporte;
            this.isGuardados=true;
        },
        formatoFechaText(){
            console.log(this.fecha_nac);
            if(this.fecha_nac.length==2 || this.fecha_nac.length==5){
                this.fecha_nac+="/";
            }
        },
		submitTemas() {
			if (this.temas.length > 0) {
				this.$api
					.temas_interes({
						id_categoria: this.temas
							.filter(tema => tema.activo)
                            .map(
                                tema => tema.tema.id,
                            )
					})
					.then(response => {
						if (typeof response.data.error !== "undefined") {
							this.$router.push({
								name: "error404"
							});
						}
						console.log(response.data);
					})
					.catch(error => {
						console.log("error temas" + error);
					});
			}
		},
		cargarTemas() {
			this.$api
				.get_temas_interes(this.user.email)
				.then(response => {
					console.log("response get temas", response);
					if (response.data.response == 200) {
                        this.temasSelect = response.data.data_select;

						this.temas = response.data.data.map(tema => {
							return {
								activo:false,
								tema
							};
						});

                        this.temas.forEach((e1)=>this.temasSelect.forEach((e2)=> {
                            if(e1.tema.id== e2.id){
                             e1.activo=true;
                            }
                          }
                        ));


                        //Se utiliza funcion contenedora que permite pasar el arreglo de temas selececcionados como parametro a la funcion sort
                        function addPropToCompareAndSort ( temasSelectArry ) {
                            //retornar funcion de ordenamiento
                            return function (temaA, temaB){
                                //console.log("Tema A: ", temaA, "Tema B: ", temaB, "Temas Seleccionados: ", temasSelectArry);
                                //Se utiliza funcion contenedora que permite pasar el arreglo de temas A o B como parametro a la funcion find
                                function addPropToFind (elementoFindComparar){
                                    //retorna funcion de busqueda
                                    return function (element, index, array){
                                        //console.log("Tema Buscado: ", elementoFindComparar, "Tema Seleccionado Find Comparar", element, "Index: ", index, "arra", array);
                                        //Si el elemento actual es igual al elemento que se esta buscado 
                                        if(elementoFindComparar.tema.categoria === element.categoria ){
                                            //console.log("Encontrado", elementoFindComparar.tema.categoria);
                                            return true;
                                        }
                                    }
                                }

                                //Buscar tema A en los arreglos seleccionados
                                var temaAEncontrado = temasSelectArry.findIndex( addPropToFind(temaA) );
                                //console.log("Resultado de la busqueda del tema a", temaAEncontrado);

                                //Buscar tema B en los arreglos seleccionados
                                var temaBEncontrado = temasSelectArry.findIndex( addPropToFind(temaB) );
                                //console.log("Resultado de la busqueda del tema b", temaBEncontrado);

                                //Ninguno de los elementos fue encotrado
                                if( temaAEncontrado == -1 && temaBEncontrado == -1 ){
                                    //Los indices de los temas se dejan ingual
                                    //console.log("A y B quedan iguales");
                                    return 0;
                                }

                                //Uno de los 2 elementos fue encontrado y el otro no
                                if( temaAEncontrado != -1 && temaBEncontrado == -1 ){
                                    //A va primero
                                    //console.log("A va primero");
                                    return -1;
                                }

                                if( temaAEncontrado == -1 && temaBEncontrado != -1 ){
                                    //B va priemro
                                    //console.log("B va primero");
                                    return 1;
                                }

                                //Si ambos elementos fueron encontrados (Comprar indices)
                                if( temaAEncontrado != -1 && temaBEncontrado != -1 ){
                                    //Comparar indices
                                    //console.log("se retorna resta de indices");
                                    return temaAEncontrado-temaBEncontrado;
                                }
                            
                            }
                        }

                        //Reordenar temas en base a temas selecionados
                        this.temas.sort( addPropToCompareAndSort( this.temasSelect ) );
                        //console.log("tema ordenado", this.temas);

					} else {
						this.temas = [];
					}
				})
				.catch(error => {
					//console.log("error temas" + error);
				});
		},
		/**
		 * Prevenir submit del form al escoger una dirección de google.
		 */
		direccionKeyPress(e) {
			if (e.key == "Enter") {
				e.preventDefault();
				return false;
			}
		},
		/**
		 * Prevenir submit del form al escoger una dirección de google.
		 */
		direccionKeyUp(e) {
			if (e.key == "Enter") {
				e.preventDefault();
				return false;
			}
		},
		loadUserInfo() {
			this.id = String(this.user.id) || 0;
			this.name = this.user.name == null ? "" : String(this.user.name);
			this.apellido = this.user.apellido == null ? "" : String(this.user.apellido) ;
			this.email = this.user.email == null ? "" : String(this.user.email) ;
			this.telefono = this.user.telefono == null ? "" : String(this.user.telefono) ;
			this.direccion = this.user.direccion == null ? "" : String(this.user.direccion) ;
			this.sexo = this.user.sexo == null ? "" : String(this.user.sexo);
			this.fecha_nac = this.user.fecha_nac == null ? "" : String(this.user.fecha_nac);
		},
		newDireccion(obj1, obj2, obj3) {
			this.direccion = obj1.newVal;
		},
		submit(e) {
			this.validated = true;
			let isValid = true;
			if (
				this.name == "" ||
				this.apellido == "" ||
				this.direccion == "" ||
				!this.isEmailValid
			)
				isValid = false;
			if (this.password != "") {
				if (
					this.repeatPassword == "" ||
					this.repeatPassword != this.password
				)
					isValid = false;
			}

			let newUserData = {
				id_portal: this.portal.id,
				name: this.name,
				apellido: this.apellido,
				email: this.email,
				telefono: this.telefono,
				direccion: this.direccion,
				sexo: this.sexo,
				fecha_nac: this.fecha_nac,
				id_pais: this.portal.id_pais
			};

			if (this.password != "") newUserData.password = this.password;

			if (isValid) {
				this.showAlert({
					iconSpin: true,
					message: "Guardando...",
					icon: "spinner"
				},true);
				this.$store
					.dispatch("updateUser", newUserData)
					.then(response => {


                    if(response.response=="200"){
                        this.isResponseMessageModalVisible=true;
                        this.MessageModal="DATOS ACTUALIZADOS";
                        this.isGuardados=true;
                    }else{
                        this.isResponseMessageModalVisible=true;
                        this.MessageModal=response.message;
                        this.isGuardados=false;
                    }

                    setTimeout(() => {
					this.isResponseMessageModalVisible=false;
				    }, 2000);

						// Guardar temas
						this.submitTemas();


					});
			}
		},
		showAlert(options, autoHide) {
			this.alert.visible = true;
			this.alert = Object.assign(this.alert, options);
			if (autoHide)
				setTimeout(() => {
					this.alert.visible = false;
				}, 3000);
        },
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        }
	},
	mounted() {
		this.loadUserInfo();
        this.cargarTemas();
	}
};
</script>

